<template>
  <credit-card-credentials-onboarding v-if="!sourceName" :on-connection="cardConnection"/>
  <div v-else>
    <credentials-details-with-async-fallback
      :handle-back="deletePageParams"
      :source="source"
      :loading-start-time="loadingStartTime"
      :is-loading="isLoading">
      <template v-slot:credentials>
        <credentials-details :invalid-credentials="invalidCredentials"
                             :source="source"
                             :name-already-used-error="nameAlreadyUsedError"
                             :set-name-already-in-use-error="setNameAlreadyInUseError"
                             :save-credentials-error="saveCredentialsError"
                             :on-save="saveCredentials"/>

      </template>
    </credentials-details-with-async-fallback>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import Segment from '../../../../../../Segment';
import CreditCardCredentialsOnboarding from './CreditCardCredentialsOnboarding.vue';
import sourcesFields from '../../../../../../constants/sourcesFields';
import CredentialsDetailsWithAsyncFallback from '../../../../../../base-components/onboarding/CredentialsDetailsWithAsyncFallback.vue';
import CredentialsDetails from '../../../../../../base-components/onboarding/CredentialsDetails.vue';

export default {
  name: 'CreditCardConnectionFlow',
  components: {
    CreditCardCredentialsOnboarding,
    CredentialsDetailsWithAsyncFallback,
    CredentialsDetails,
  },
  async created() {
    Segment.trackUserGot('CreditCardConnectionEntered');
  },
  computed: {
    ...mapState('onboardingState', ['isLoading', 'nameAlreadyUsedError', 'saveCredentialsError', 'loadingStartTime']),
    ...mapGetters('onboardingState', ['invalidCredentials', 'sourceName']),
    source() {
      return _.find(sourcesFields.allSourceFields, { sourceName: this.sourceName });
    },
  },
  methods: {
    ...mapActions('onboardingState', ['nextPage', 'deletePageParams', 'saveCredentials']),
    ...mapMutations('onboardingState', ['setPageParams', 'setNameAlreadyInUseError']),
    cardConnection(sourceName) {
      this.setPageParams({ sourceName });
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
